import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UpdateNormalOnboarding from "./update";
import {
    getLeadInfraId,
    updateNormalOnboardingData,
    getNormalOnboarding
} from 'services/redux/brandActivtion/conductCamp/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    leadInfraId: state.ConductCampReducer.leadInfraId,
    normalOnboradingData: state.ConductCampReducer.normalOnboradingData
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            getLeadInfraId,
            updateNormalOnboardingData,
            getNormalOnboarding
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UpdateNormalOnboarding);
